import { Button } from '@/components'
import { useCampaignSlug } from '@/lib/useCampaignSlug'
import { useRouter } from 'next/router'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const NotFound = ({ withHome = true }: { withHome?: boolean }) => {
  const { t } = useTranslation()
  const router = useRouter()
  const { gen } = useCampaignSlug()

  return (
    <div className="bg-main px-4 pt-10 pb-6" style={{ height: '100vh' }}>
      <h1 className="text-center text-big font-bold text-sub">404</h1>
      <p className="text-center text-sm font-bold text-sub">Not Found</p>
      <p className="mt-10 text-center text-xsss text-sub">
        {t('error.404.page_not_found', 'お探しのページは見つかりませんでした。')}
      </p>
      {withHome && (
        <div className="mt-14">
          <Button
            text={t('error.back_home', 'ホームへ')}
            width="w-9/12"
            borderColor="border-sub"
            onClick={() => {
              router.push(gen('/'))
            }}
          />
        </div>
      )}
    </div>
  )
}
